import { Selectable } from "./abstractions/Selectable";

export class Scope extends Selectable {
    code: string;
    name: string;

    constructor(code: string, name: string, selected: boolean) {
        super(name, code);
        this.code = code;
        this.name = name;
        this.selected = selected;
    }
}
